<tm-bottom-panel [isVisible$]="isVisible$" [title$]="title$" (closed)="onCloseClick()">

  @if (tabs().length === 0) {
    <span class="no-tabs">
      @if (isLoadingTabs$ | async) {
        <span>
          <mat-spinner color="primary" mode="indeterminate" diameter="20"></mat-spinner>
        </span>
      } @else {
        <span i18n="@@core.attribute-list.no-data-found">No layers with administrative data found</span>
      }
    </span>
  }

  @if (tabs().length > 0) {
    <mat-tab-group class="tab-group"
      mat-stretch-tabs="false"
      animationDuration="0ms"
      (selectedTabChange)="onSelectedTabChange($event);">
      @for (tab of tabs(); track trackByTabId(index, tab); let index = $index) {
        <mat-tab
          [label]="tab.label">
          <ng-template mat-tab-label>
            <div class="label">{{tab.label}}</div>
            @if (selectedTab() === tab.id) {
              <button mat-icon-button
                      i18n-tmTooltip="@@core.attribute-list.column-settings"
                      tmTooltip="Column settings"
                      class="table-options-button"
                      (click)="openColumnSelection($event, tab)">
                <mat-icon svgIcon="more"></mat-icon>
              </button>
            }
          </ng-template>
        </mat-tab>
      }
    </mat-tab-group>
    <tm-attribute-list-tab [id]="selectedTab()"></tm-attribute-list-tab>
  }

</tm-bottom-panel>
